module.exports = __webpack_public_path__ + "img/import-loading-animation.fdb4c59.gif";